<mat-form-field subscriptSizing="dynamic"
                class="st-date-time-range"
                [matTooltip]="label">
    <mat-label *ngIf="label">{{label}}</mat-label>
    <mat-date-range-input [formGroup]="range"
                          [disabled]="disabled"
                          [rangePicker]="picker">

        <input matStartDate
               formControlName="from"
               (dateChange)="dateChange($event)"
               placeholder="Start date" />
        <input matEndDate
               formControlName="to"
               (dateChange)="dateChange($event)"
               placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix
                           [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker (closed)="closed()"
                           panelClass="st-date-time-picker-calendar"
                           #picker>
        <mat-date-range-picker-actions>
            <button mat-button
                    (click)="clearDate()"
                    matDatepickerCancel>
                {{languageSettings.PSTWebDatePickerClearLabel}}
            </button>
            <button mat-button
                    class="st-date-time-range-apply"
                    matDatepickerApply>
                {{languageSettings.PSTWebApplyButtonLabel}}
            </button>
        </mat-date-range-picker-actions>
    </mat-date-range-picker>
    <ng-container *ngIf="hasSuffix"
                  matSuffix>
        <ng-content select="[suffix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasPrefix"
                  matPrefix>
        <ng-content select="[prefix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasError"
                  matError>
        <ng-content select="[error]"></ng-content>
    </ng-container>
</mat-form-field>